import { Button } from "@design-system/Button/Button";
import { WithHotkey } from "@design-system/Button/WithHotkey";
import { RECONCILIATION_PRIMARY_HOTKEY } from "./helpers";

interface Props {
    onHide: () => void;
    onSuccess?: () => void;
}

export const ReconciliationCloseButton: React.FC<Props> = ({
    onHide,
    onSuccess,
}) => (
    <WithHotkey
        hotKey={RECONCILIATION_PRIMARY_HOTKEY}
        hotKeyOptions={{
            description: "Close reconciliation",
        }}
        hotKeyDisplayPosition="inline"
    >
        {(hotkeyHint) => (
            <Button
                variant="primary"
                size="md"
                onClick={() => {
                    onHide();
                    onSuccess?.();
                }}
                rightIcon={hotkeyHint}
            >
                Close
            </Button>
        )}
    </WithHotkey>
);
